import { Stack } from "@mui/material";

import { BookingCardContentWrapper } from "../../Shift/CardContentWrapper";
import { type TimeSlot } from "../../Shift/Open/types";
import { BookingCardSummaryWrapper } from "../../Shift/SummaryWrapper";
import { TimeSlotIndicator } from "../../Shift/TimeSlotIndicator";
import { ShiftDate } from "./ShiftDate";
import { ShiftHistoryCardFooter } from "./ShiftHistoryCardFooter";
import { ShiftTimeDetails } from "./ShiftTimeDetails";
import { WorkplaceInfo } from "./WorkplaceInfo";

export interface ShiftHistoryCardContentProps {
  shiftId: string;
  timeSlot: TimeSlot;
  shiftStartDate: Date;
  shiftEndDate: Date;
  workplaceId: string;
  workplaceName: string;
  workplaceTimezone: string;
  totalPayInDollars: number;
  qualificationText: string;
  isVerified: boolean;
  isMissedPunchRequestEnabled: boolean;
  hasPendingExtraWorkedTimeRequest: boolean;
  isTimesheetUploaded: boolean;
  onUploadTimesheetClick: () => void;
  onChatWithSupportClick: () => void;
}

export function ShiftHistoryCardContent(props: ShiftHistoryCardContentProps) {
  const {
    shiftId,
    timeSlot,
    shiftStartDate,
    shiftEndDate,
    workplaceId,
    workplaceName,
    workplaceTimezone,
    totalPayInDollars,
    qualificationText,
    isVerified,
    isMissedPunchRequestEnabled,
    hasPendingExtraWorkedTimeRequest,
    isTimesheetUploaded,
    onUploadTimesheetClick,
    onChatWithSupportClick,
  } = props;

  return (
    <BookingCardContentWrapper>
      <BookingCardSummaryWrapper>
        <TimeSlotIndicator timeSlot={timeSlot} />
        <Stack spacing={3}>
          <ShiftDate shiftStartDate={shiftStartDate} workplaceTimezone={workplaceTimezone} />
          <ShiftTimeDetails
            shiftStartDate={shiftStartDate}
            shiftEndDate={shiftEndDate}
            workplaceTimezone={workplaceTimezone}
          />
          <WorkplaceInfo workplaceId={workplaceId} workplaceName={workplaceName} />
        </Stack>
      </BookingCardSummaryWrapper>
      <ShiftHistoryCardFooter
        shiftId={shiftId}
        totalPayInDollars={totalPayInDollars}
        qualificationText={qualificationText}
        isVerified={isVerified}
        isMissedPunchRequestEnabled={isMissedPunchRequestEnabled}
        hasPendingExtraWorkedTimeRequest={hasPendingExtraWorkedTimeRequest}
        isTimesheetUploaded={isTimesheetUploaded}
        onUploadTimesheetClick={onUploadTimesheetClick}
        onChatWithSupportClick={onChatWithSupportClick}
      />
    </BookingCardContentWrapper>
  );
}
